import { colorLookup } from '@medifind/utils';

import { SVG } from './SVG';
const IconMarker = (props) => {
  const { color } = props;
  const colorCode = colorLookup(color) ?? colorLookup('blue');
  return (
    <SVG width="23" height="26" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.7889 3.19045C14.5598 -1.07482 7.45143 -1.05213 3.22239 3.19045C-1.07413 7.52378 -1.07413 14.5569 3.22239 18.8903L9.74591 25.4697C10.1058 25.81 10.5557 25.9915 11.0056 25.9915C11.4555 25.9915 11.9279 25.81 12.2653 25.4697L18.7889 18.8903C20.8584 16.7803 22.0056 13.9898 22.0056 11.0404C22.0056 8.06829 20.8584 5.27771 18.7889 3.19045Z"
        fill={colorCode}
      />
    </SVG>
  );
};

export { IconMarker as default, IconMarker };
